import { createSetState, createStore } from '@flowus/common/zustand/utils';
import type { AiCover } from './type';

export const AiCoverStore = createStore<AiCover>(() => ({ html: '', loading: false }));

export const setAiCoverStore = createSetState(AiCoverStore);
